<div class="alert alert-warning alert-in-section-message" role="alert">
    <p>
        <ng-content></ng-content>
    </p>
</div>